import React, { Component } from 'react';
import CampaignOrderButtonProps from './CampaignOrderButton.props';
import CampaignOrderButtonState from './CampaignOrderButton.state';
import ProductProperties from '../../interfaces/ProductProperties/ProductProperties';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import { Navigate } from 'react-router-dom';
import { UrlPaths } from '../../interfaces/UrlPaths/UrlPaths';
import ProductPropertiesQueryInformation from '../../interfaces/ProductProperties/ProductPropertiesQueryInformation';
import IMultiTestCustomerDataPageState from '../MultiTestCustomerData/MultiTestCustomerData.state';
import { TrackingVariantETracker } from '../../interfaces/Tracking/TrackingVariantETracker';
import TrackingMeta from '../../interfaces/Tracking/TrackingMeta';
import track from 'react-tracking';

@track({/*  */})
export default class CampaignOrderButton extends Component<CampaignOrderButtonProps, CampaignOrderButtonState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;
    private initCounter: number;
    private step: string;

    constructor(props: CampaignOrderButtonProps) {
        super(props);
        this.state = {
            this: this,
            key: 'value',
            navigate: undefined,
            pageDetails: {
                pageType: this.props.pageDetails.pageType || '',
                campaignId: this.props.pageDetails.campaignId || '',
                preselectMembership: this.props.pageDetails.preselectMembership,
                preselectFirstCard: this.props.pageDetails.preselectFirstCard || false,
            },
            productChecked: false,
            productsInLS: false,
            orderData: {},
        };

        this.init = this.init.bind(this);
        this.createCampaignOrderButton = this.createCampaignOrderButton.bind(this);
        this.addProductsToIndividualBasket = this.addProductsToIndividualBasket.bind(this);
        this.getChosenProducts = this.getChosenProducts.bind(this);
        this.changePageIfNoForm = this.changePageIfNoForm.bind(this);
        this.goToStep = this.goToStep.bind(this);
        this.getProductsFromLs = this.getProductsFromLs.bind(this);
        this.preSelectIfProductsInLS = this.preSelectIfProductsInLS.bind(this);
        this.addEventListenerToSelectionInput = this.addEventListenerToSelectionInput.bind(this);

        this.initCounter = 0;
        this.step = 'step1';
    }

    componentDidMount() {
        if (this.initCounter === 0) {
            this.init();
            this.trackStep();
        }

        setTimeout(() => {
            this.changePageIfNoForm();
        }, 500)
    }

    componentDidUpdate(prevProps: Readonly<CampaignOrderButtonProps>, prevState: Readonly<CampaignOrderButtonState>): void {
        if (prevState.productChecked !== this.state.productChecked) {

            const newCampaignOrderButton = document.getElementById('campaignOrderButton');
            if (!this.state.productChecked) {
                newCampaignOrderButton?.setAttribute('disabled', 'true');
            } else {
                newCampaignOrderButton?.removeAttribute('disabled');
            }
        }
    }

    init () {
        if (this.props.pageDetails.campaignId && this.props.pageDetails.pageType) {
            this.initCounter++;
            this.getProductsFromLs(this.props.pageDetails.campaignId, this.props.pageDetails.pageType);
            this.createCampaignOrderButton();
            this.watchCheckedStatusOfSelection();
            this.addEventListenerToSelectionInput();
        } else {
            // TODO: Catch error
            console.log('pageDetails incomplete: ', this.props.pageDetails);
        }
    }

    addEventListenerToSelectionInput() {
        const checkboxes = document.querySelectorAll('.product-selection-card-v2__checkbox-container')

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('click', (e) => {
                this.watchCheckedStatusOfSelection();
            })
        })

        const covers = document.querySelectorAll('.product-selection-card-v2__image-wrapper')

        covers.forEach(cover => {
            cover.addEventListener('click', (e) => {
                this.watchCheckedStatusOfSelection();
            })
        })
    }




    watchCheckedStatusOfSelection() {
        // if singleProduct productSelected should be always true
        if (this.props.pageDetails.singleProduct) {
            this.setState({
                productChecked: true
            })
            return;
        }

        const checkboxes = document.querySelectorAll('.checkbox__input');

        // if counter if 0, no checkbox is 'checked'
        // if above 0 at least one checkbox is checked and campaignOderButton should be enabled
        let counterCheckedInput = 0;

        checkboxes.forEach(checkbox => {
            if ((checkbox as HTMLInputElement).checked) {
                counterCheckedInput++
            }
        })

        if (counterCheckedInput > 0) {
            this.setState({
                productChecked: true
            })
        } else {
            this.setState({
                productChecked: false
            })
        }
    }

    // switching content via css if user gets on route
    changePageIfNoForm() {
        const selectionPage = document.getElementById('step1page') as HTMLDivElement;
        const step2page = document.getElementById('step2page') as HTMLDivElement;

        if (selectionPage.style.display === 'none') {
            step2page.style.display = 'none';
            selectionPage.style.display = 'block';
        }
    }

    getProductsFromLs(campaignId: string, pageType: string) {
        const cartData = this.context.localStorageProvider.getProductInformationForCampaingOrder(campaignId, pageType);

        if (!cartData) {
            // console.log('empty cardData');
            // empty array to this function will cause reload of page
            this.preSelectIfProductsInLS([]);
            return;
        }

        this.setState({
            productsInLS: true
        }, () => {
            // console.log('preselectIfProductIn');
            this.preSelectIfProductsInLS(cartData);
        })

        return cartData;
    }

    // Preselecting if Products in LS - Reloading Window if not
    preSelectIfProductsInLS(cartData: Array<ProductProperties>) {
        const productIdsFromLS = [] as Array<string>;

        const productsOnSelectionPage = document.querySelectorAll('.product-selection-card-v2__checkbox-container');

        cartData.forEach(product => {
            productIdsFromLS.push(product.magicNumber);
        })

        productsOnSelectionPage.forEach((product, index) => {
            const magicNumber = product.getAttribute('data-id');
            const productInputState = product.querySelector('.checkbox__input') as HTMLInputElement;

            if (magicNumber && productIdsFromLS.length > 0) {
                if (productInputState.checked) {
                    this.simulateClick(product);
                }

                if (productIdsFromLS.includes(magicNumber)) {
                    this.simulateClick(product);
                }
            } else if (productIdsFromLS.length <= 0 && index !== 0) {
                if (productInputState.checked) {
                    this.simulateClick(product);
                }
                productInputState.checked = false;
                // window.location.reload();
            } else if (productIdsFromLS.length <= 0 && index === 0 && this.props.pageDetails.preselectFirstCard && String(this.props.pageDetails.preselectFirstCard) === 'true') {
                // nothing in ls and 1st Card ...
                // console.log('select firstcard ',this.props.pageDetails.preselectFirstCard);
                if (!productInputState.checked) {
                    this.simulateClick(product);
                }
                productInputState.checked = true;
            }
        })
    }

    // simulate click on any Element given to function
    simulateClick(elem: Element) {
        // Create our event (with options)
        const evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });
        // If cancelled, don't dispatch our event
        const canceled = !elem.dispatchEvent(evt);
    }

    // building button upon details of existing button - Entry of SPA on this page
    async createCampaignOrderButton() {
        const campaignOrderButtonWrapper = document.getElementById('campaign_order_button');
        const buttonTitle = this.context.i18nProvider.get('selectionPageCampaign.mgs.nextButtonTitle') || 'Weiter zur Freischaltung des Tests';
        const buttonClassName = "cta-button step2button cta-button--button-red";
        const buttonId = 'campaignOrderButton';
        const frameworkContract = this.props.pageDetails.frameworkContract ? `data-framework-contract="${this.props.pageDetails.frameworkContract}"` : '';
        const singleProduct = this.props.pageDetails.singleProduct ? 'data-single-product="true"' : '';
        const headerImage= this.props.pageDetails.headerImg ? `data-header-image="${this.props.pageDetails.headerImg}"` : '';
        const buttonElement = `
            <button
                class="${buttonClassName}"
                id="${buttonId}"
                data-fs-id="${this.props.pageDetails.fsId}"
                ${frameworkContract}
                ${singleProduct}
                data-campaign-id="${this.props.pageDetails.campaignId}"
                data-page-type="${this.props.pageDetails.pageType}"
                data-preselect-membership="${this.props.pageDetails.preselectMembership}"
                data-preselect-firstcard="${this.props.pageDetails.preselectFirstCard}"
                disabled="true"
                >
                ${buttonTitle}
            </button>
        `

        if (!campaignOrderButtonWrapper) {
            return;
        }
        campaignOrderButtonWrapper.innerHTML = buttonElement;
        const newCampaignOrderButton = document.getElementById(buttonId);
        // campaignOrderButton?.appendChild(newCampaignOrderButton);

        if (newCampaignOrderButton) {
            newCampaignOrderButton.addEventListener('click', () => {
                this.clickListenerCampaignOrderButton();
            })
        } else {
            console.log('champaignOrderButton could not be found')
        }
        //  Button of campaign order
        //     <button className="cta-button campaignOrderButton" id="campaignOrderButton" data-fs-id="FSID12345" data-campaign-id="KA12345" data-page-type="mgs">Weiter zur Freischaltung des Tests</button>
        //
    }

    // Tracking step with eTracker
    trackStep() {
        if (!this.context.sessionStorageProvider.getCounterForSteps(this.state.pageDetails.campaignId, this.state.pageDetails.pageType, this.step)) {
            this.context.sessionStorageProvider.setCounterForSteps(this.state.pageDetails.campaignId, this.state.pageDetails.pageType, this.step);
            this.trackStepHandler();

            // console.log('getCounterSteps', this.context.sessionStorageProvider.getCounterForSteps(this.state.pageDetails.campaignId, this.state.pageDetails.pageType, this.step));
        }
    }

    @track((props: CampaignOrderButtonProps, state: IMultiTestCustomerDataPageState) => ({
        trackingMeta: {
            variant: TrackingVariantETracker.WATCHSTEP
        } as TrackingMeta,
        pageType: props.pageDetails.pageType,
        campaignId: props.pageDetails.campaignId,
        step: 'step1'
    }))
    trackStepHandler() {
        return;
    }

    async clickListenerCampaignOrderButton() {
        await this.getChosenProducts(true);

        setTimeout(() => {
            this.goToStep(2);
            this.setState({
                navigate: UrlPaths.CUSTOMERDATAPAGE,
            })
        }, 200)
    }

    goToStep(number: number) {
        const step1page = document.getElementById('step1page');
        const step2page = document.getElementById('step2page');

        if (number === 2) {
            if (step1page && step2page) {
                step2page.style.display = 'block'
                step1page.style.display = 'none'
            }
        } else if (number === 1) {
            if (step1page && step2page) {
                step2page.style.display = 'none'
                step1page.style.display = 'block'
            }
        }
    }

    fallbackForEmptyQueryInformation(ppfs : ProductProperties){
        if (ppfs.queryInformation.title === ''){
            ppfs.queryInformation.title = String(ppfs.title);
        }
        return ppfs.queryInformation;
    }

    async getChosenProducts(deleteConfigOptions = false) {

        // console.log('getChosenProducts',':::');
        const getListElementsFromSelection = document.querySelector('.product-selection-multitest-result__yourChoiceList')?.children;
        const campaignId = this.props.pageDetails.campaignId;
        const pageType = this.props.pageDetails.pageType;

        if (!getListElementsFromSelection || !campaignId || !pageType) {
            // TODO: Add error case
            console.log('something is missing in pageDetails: ', this.props.pageDetails);
            console.log('noElement: ', getListElementsFromSelection);
            return;
        }

        if (this.props.pageDetails.singleProduct === 'true') {
            this.getSingleProductFromPage();
            return;
        }

        const productPropertiesArray = [] as Array<ProductProperties>;

        for(let i = 0; i < getListElementsFromSelection.length; i++) {
            const magicNumber = getListElementsFromSelection[i].getAttribute('data-id');
            if (magicNumber) {
                const productPropertiesFromServer = await this.getProductPropertiesFromServer(magicNumber) as ProductProperties;

                if (productPropertiesFromServer.queryInformation === undefined) {
                    productPropertiesFromServer.queryInformation = await this.getProductInformationFromQuery(magicNumber) as unknown as ProductPropertiesQueryInformation;
                    // productPropertiesFromServer.queryInformation = this.fallbackForEmptyQueryInformation(productPropertiesFromServer);
                }

                // 2024-02-12 .configOptions not necessary for this type of page
                // keeping the values from the api-request leads to overwriting frameworkContract from orderbutton (--> frameworkContract: "nein")
                if (deleteConfigOptions) {
                    delete productPropertiesFromServer.configOptions;
                }
                // console.log('productPropertiesFromServer AFTER',':::',productPropertiesFromServer);

                productPropertiesArray.push(productPropertiesFromServer);
            }
        }

        if (productPropertiesArray.length > 0) {
            // this.setState({
            //     orderData: productPropertiesArray
            // })
            this.addProductsToIndividualBasket(productPropertiesArray);
        }

    }

    async getSingleProductFromPage() {
        const singleProductMagicNumber = document.querySelector('.product-selection-card-v2')?.getAttribute('data-product-id');

        if (singleProductMagicNumber) {
            const productPropertiesFromServer = await this.getProductPropertiesFromServer(singleProductMagicNumber) as ProductProperties;

            if (productPropertiesFromServer.queryInformation === undefined) {
                productPropertiesFromServer.queryInformation = await this.getProductInformationFromQuery(singleProductMagicNumber) as unknown as ProductPropertiesQueryInformation;
                // productPropertiesFromServer.queryInformation = this.fallbackForEmptyQueryInformation(productPropertiesFromServer);
            }

            this.addProductsToIndividualBasket([productPropertiesFromServer]);
        }
    }

    // ToDo: handle products like tjstbprSTV for which no product page exists 2024-02-12
    getProductPropertiesFromServer(magicNumber: string): Promise<ProductProperties | Response> {
        const url = `/order-api/getOrderInformation/${magicNumber}`;
        // const token = window.localStorage.getItem('accessToken') || undefined;

        // console.log('getProductPropertiesFromServer',':::',magicNumber, this.context?.requestProvider.getData(url));

        return this.context?.requestProvider.getData(url);
    }

    async getProductInformationFromQuery(magicNumber: string): Promise<ProductPropertiesQueryInformation> {
        // console.log('getProductInformationFromQuery',':::', magicNumber);
        const baseUrl = '/delivery-service/select/de?q=shopTestProductId_s:';
        const url = baseUrl + magicNumber;
        const queryInformation = await this.context?.requestProvider.getData(url);
        return {
            title: queryInformation.response.docs[0]?.IN_NAME as string || '',
            imageAlt: queryInformation.response.docs[0]?.imageAlt_s as string || '',
            imageSrc: queryInformation.response.docs[0]?.image_s as string || '',
            href: (queryInformation.response.docs[0]?.IN_LINK as string) || undefined,
        } as ProductPropertiesQueryInformation;
    }

    addProductsToIndividualBasket(productPropertiesArray: Array<ProductProperties>) {
        if (this.props.pageDetails.campaignId && this.props.pageDetails.pageType && productPropertiesArray.length > 0) {
            this.context.localStorageProvider.setProductInformationInLocalStorageCampaignOrder(productPropertiesArray, this.props.pageDetails.campaignId, this.props.pageDetails.pageType);
        }
    }

    render(): React.ReactNode {
        if (this.state.navigate) {
            return <Navigate to={this.state.navigate} />
        }

        return (
            <>
                <button className="campaignorder-button" disabled style={{display: 'none'}}></button>
            </>
        );
    }
}
